<template>
  <div class="axis-timeline">
    <div class="circle-continuous" v-if="showCircle == 0">
      <img class="img-circle" src="https://res.cloudinary.com/dhcti0lrk/image/upload/v1613489789/globalwork/steps/Vector_1_qkiqcq.png" alt="">
    </div>        
    <div class="circle" v-if="showCircle == 1"></div>
    <div class="circle-dotted" v-if="showCircle == 2"></div>
  </div>
</template>

<script>
  export default {
    props: {
      event: Object,
      events: Array,
      index: null
    },
    computed: {
      showCircle() {
        if (this.event.status_event == 'finished') {
          return 0
        } else {
          if (this.index > 0) {
            if (this.events[this.index - 1].status_event == 'finished') return 1
          }
          return 2
        }
      }
    }
  }
</script>

<style scoped>

</style>